module.exports = __webpack_public_path__ + "static/media/ic_option.bc176eba.svg";